

import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

//eslint-disable-next-line
let config = {
    apiKey: "AIzaSyCU7idchaOuAMHWrxn9PyYeB1WejDlEXmU",
    authDomain: "five-words-story.firebaseapp.com",
    databaseURL: "https://five-words-story.firebaseio.com",
    projectId: "five-words-story",
    storageBucket: "five-words-story.appspot.com",
    messagingSenderId: "330710552298",
    appId: "1:330710552298:web:e29bf57707569f8a"
}
let test = {
    apiKey: "AIzaSyAlg4EbIuzn6Uxz-tD9VRCIrr7m6PkjUiI",
    authDomain: "test-781ac.firebaseapp.com",
    databaseURL: "https://test-781ac.firebaseio.com",
    projectId: "test-781ac",
    storageBucket: "test-781ac.appspot.com",
    messagingSenderId: "760785602127",
    appId: "1:760785602127:web:95ee369afd7de699be8c3a"
}

export const FieldValue = app.firestore.FieldValue;
export const firebase = app;

export default app.initializeApp(config);